import React, { createContext, useContext } from 'react';
const ImageSlotContext = createContext<boolean>(false);
export function ImageSlotProvider({
  showLabels,
  children
}: {
  showLabels: boolean;
  children: React.ReactNode;
}) {
  return <ImageSlotContext.Provider value={showLabels} data-id="element-581" data-mp="348wunzq70dtb">{children}</ImageSlotContext.Provider>;
}
export function useShowSlotLabels(): boolean {
  return useContext(ImageSlotContext);
}